import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack } from "@ui/Stack";

type Props = {
	symbol: string;
	label: string;
};

export const TabLabel = (props: Props) => {
	return (
		<HStack spacing="small" align="center">
			<MaterialSymbol symbol={props.symbol} />
			{props.label}
		</HStack>
	);
};
